import React from 'react';
import './authFlow.css';

const logo = '/logo192.png';

export default function AuthFlowLayout({
  eyebrow,
  heroTitle,
  heroText,
  icon,
  benefitTitle,
  benefitText,
  formEyebrow,
  title,
  subtitle,
  children,
}) {
  return (
    <main className="auth-flow-page">
      <div className="auth-flow-shell">
        <section className="auth-flow-hero">
          <div className="auth-flow-logo">
            <img src={logo} alt="YaBatho" />
          </div>
          <p className="auth-flow-eyebrow">{eyebrow}</p>
          <h1>{heroTitle}</h1>
          <p className="auth-flow-hero-copy">{heroText}</p>
          <div className="auth-flow-benefit">
            <span className="auth-flow-benefit-icon" aria-hidden="true">{icon}</span>
            <div>
              <strong>{benefitTitle}</strong>
              <p>{benefitText}</p>
            </div>
          </div>
        </section>

        <section className="auth-flow-card">
          <header>
            <p className="auth-flow-form-eyebrow">{formEyebrow}</p>
            <h2>{title}</h2>
            <p className="auth-flow-subtitle">{subtitle}</p>
          </header>
          {children}
        </section>
      </div>
    </main>
  );
}
